(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('TypeSearch', TypeSearch);

    TypeSearch.$inject = ['$resource'];

    function TypeSearch($resource) {
        var resourceUrl =  'api/_search/types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
